import { render, staticRenderFns } from "./CurrencyExchangeMarginRateRow.vue?vue&type=template&id=440a38b6&"
import script from "./CurrencyExchangeMarginRateRow.vue?vue&type=script&lang=js&"
export * from "./CurrencyExchangeMarginRateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports